import { useEffect, useState } from "react";
import { LineChartReport as DetailsModalLineChartReport } from "../lineChartReport";
import { Co2Config, HumidityConfig, IntTempConfig, MechanicalVibrationsConfig } from "./chartConfig";

export const LineChartReport = ({ sensor, dataToChart, alarms, powerTensionNominal }) => {

    let config = null;
    const [minData, setMinData] = useState(0);
    const [maxData, setMaxData] = useState(0);
    const [datasets, setDatasets] = useState([]);
    const [loadingChart, setLoadingChart] = useState(true);

    useEffect(() => {
        config = sensor === 'temperature' ? IntTempConfig :
            sensor === 'humidity' ? HumidityConfig :
                sensor === 'mechnical-vibrations' ? MechanicalVibrationsConfig :
                    sensor === 'co2' ? Co2Config : IntTempConfig
        if ("sensor1Values" in dataToChart && "sensor2Values" in dataToChart && "sensor3Values" in dataToChart && "sensor4Values" in dataToChart && !("sensor5Values" in dataToChart)) {

            setDatasets([
                {
                    label: 'Temp P',
                    data: dataToChart.sensor1Values,
                    borderColor: config.borderColor1,
                    backgroundColor: config.backgroundColor1,
                    spanGaps: false,
                    lineTension: 0.5,
                    borderWidth: 2,
                    pointStyle: 'rect',
                },
                {
                    label: 'Temp S',
                    data: dataToChart.sensor2Values,
                    borderColor: config.borderColor2,
                    backgroundColor: config.backgroundColor2,
                    showLine: true,
                    spanGaps: false,
                    lineTension: 0.5,
                    borderWidth: 2,
                    pointStyle: 'rect',
                },
                {
                    label: 'Temp M',
                    data: dataToChart.sensor4Values,
                    borderColor: config.borderColor4,
                    backgroundColor: config.backgroundColor4,
                    showLine: true,
                    spanGaps: false,
                    lineTension: 0.5,
                    borderWidth: 2,
                    pointStyle: 'rect',
                },
                {
                    label: 'Temp E',
                    data: dataToChart.sensor3Values,
                    borderColor: config.borderColor3,
                    backgroundColor: config.backgroundColor3,
                    showLine: true,
                    spanGaps: false,
                    lineTension: 0.5,
                    borderWidth: 2,
                    pointStyle: 'rect',
                },
                {
                    label: "",
                    data: dataToChart.sensorMinThresholdValues,
                    borderColor: 'rgb(255, 0, 0)',
                    backgroundColor: 'rgb(255, 0, 0)',
                    borderDash: [5, 5],
                    borderWidth: 1,
                    spanGaps: false,
                    pointStyle: 'dash',
                },
                {
                    label: "",
                    data: dataToChart.sensorMaxThresholdValues,
                    borderColor: 'rgb(255, 0, 0)',
                    backgroundColor: 'rgb(255, 0, 0)',
                    borderDash: [5, 5],
                    borderWidth: 1,
                    spanGaps: false,
                    pointStyle: 'dash',
                },
            ]);
        }
        else if ("sensor1Values" in dataToChart && "sensor2Values" in dataToChart && "sensor4Values" in dataToChart && "sensor5Values" in dataToChart) {
            if (sensor === 'co2') {
                setDatasets([
                    {
                        label: 'CO2',
                        data: dataToChart.sensor1Values,
                        borderColor: config.borderColor1,
                        backgroundColor: config.backgroundColor1,
                        showLine: true,
                        lineTension: 0.5,
                        borderWidth: 2,
                        pointStyle: 'rect',
                    },
                    {
                        label: "",
                        data: dataToChart.sensorMinThresholdValues,
                        borderColor: 'rgb(255, 0, 0)',
                        backgroundColor: 'rgba(255, 0, 0, 0.5)',
                        borderDash: [5, 5],
                        borderWidth: 1,
                        pointStyle: 'dash',
                    },
                    {
                        label: "",
                        data: dataToChart.sensorMaxThresholdValues,
                        borderColor: 'rgb(255, 0, 0)',
                        backgroundColor: 'rgba(255, 0, 0, 0.5)',
                        borderDash: [5, 5],
                        borderWidth: 1,
                        pointStyle: 'dash',
                    },
                ]);
            } else if (sensor === 'humidity') {
                setDatasets([
                    {
                        label: 'Umd P',
                        data: dataToChart.sensor1Values,
                        borderColor: config.borderColor1,
                        backgroundColor: config.backgroundColor1,
                        showLine: true,
                        lineTension: 0.5,
                        borderWidth: 2,
                        pointStyle: 'rect',
                    },
                    {
                        label: 'Umd S',
                        data: dataToChart.sensor2Values,
                        borderColor: config.borderColor2,
                        backgroundColor: config.backgroundColor2,
                        showLine: true,
                        lineTension: 0.5,
                        borderWidth: 2,
                        pointStyle: 'rect',
                    },
                    {
                        label: 'Umd M',
                        data: dataToChart.sensor3Values,
                        borderColor: config.borderColor3,
                        backgroundColor: config.backgroundColor3,
                        showLine: true,
                        lineTension: 0.5,
                        borderWidth: 2,
                        pointStyle: 'rect',
                    },
                    {
                        label: "",
                        data: dataToChart.sensorMinThresholdValues,
                        borderColor: 'rgb(255, 0, 0)',
                        backgroundColor: 'rgb(255, 0, 0)',
                        borderDash: [5, 5],
                        borderWidth: 1,
                        pointStyle: 'dash',
                    },
                    {
                        label: "",
                        data: dataToChart.sensorMaxThresholdValues,
                        borderColor: 'rgb(255, 0, 0)',
                        backgroundColor: 'rgb(255, 0, 0)',
                        borderDash: [5, 5],
                        borderWidth: 1,
                        pointStyle: 'dash',
                    },
                ]);
            } else if (sensor === 'mechnical-vibrations') {

                setDatasets([
                    {
                        label: 'Vibração',
                        data: dataToChart.sensor1Values,
                        borderColor: config.borderColor1,
                        backgroundColor: config.backgroundColor1,
                        showLine: true,
                        lineTension: 0.5,
                        borderWidth: 2,
                        pointStyle: 'rect',
                    },
                    {
                        label: "",
                        data: dataToChart.sensorMinThresholdValues,
                        borderColor: 'rgb(255, 0, 0)',
                        backgroundColor: 'rgb(255, 0, 0)',
                        borderDash: [5, 5],
                        borderWidth: 1,
                        pointStyle: 'dash',
                    },
                    {
                        label: "",
                        data: dataToChart.sensorMaxThresholdValues,
                        borderColor: 'rgb(255, 0, 0)',
                        backgroundColor: 'rgb(255, 0, 0)',
                        borderDash: [5, 5],
                        borderWidth: 1,
                        pointStyle: 'dash',
                    },
                ]);

            } else if (sensor === 'ThermoKing') {
                setMinData(0);
                setMaxData(5);
                setDatasets([
                    {
                        label: 'Climatização (C)',
                        data: dataToChart.sensor1Values,
                        borderColor: 'rgb(0, 121, 239)',
                        backgroundColor: 'rgba(0, 121, 239, 0.5)',
                        showLine: true,
                        borderWidth: 2,
                        yAxisID: 'y',
                        pointStyle: 'rect',

                    },
                    {
                        label: 'Porta Fechada (P)',
                        data: dataToChart.sensor2Values,
                        borderColor: 'rgba(0, 179, 52)',
                        backgroundColor: 'rgba(0, 179, 52, 0.5)',
                        showLine: true,
                        borderWidth: 2,
                        yAxisID: 'y',
                        pointStyle: 'rect',
                    },
                    {
                        label: 'Ignição Ligada (I)',
                        data: dataToChart.sensor4Values,
                        borderColor: 'rgba(0, 0, 0)',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        showLine: true,
                        borderWidth: 2,
                        yAxisID: 'y',
                        pointStyle: 'rect',

                    },
                    {
                        label: 'Velocidade',
                        data: dataToChart.sensor5Values,
                        borderColor: 'rgba(127,255,212)',
                        backgroundColor: 'rgba(127,255,212, 0.5)',
                        lineTension: 0.5,
                        borderWidth: 1,
                        fill: true,
                        yAxisID: 'y',
                        pointStyle: 'rect',
                    },
                ]);

            } else if (sensor === "PowerTension") {
                setMinData(0);
                setMaxData(45);
                setDatasets([
                    {
                        label: 'Tensão da Bateria',
                        data: dataToChart.sensor1Values,
                        borderColor: 'rgb(255, 128, 0)',
                        backgroundColor: 'rgba(255, 128, 0, 0.5)',
                        showLine: true,
                        borderWidth: 2,
                        yAxisID: 'y',
                        pointStyle: 'rect',

                    },
                    {
                        label: 'Ignição Ligada (I)',
                        data: dataToChart.sensor2Values,
                        borderColor: 'rgba(0, 0, 0)',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        showLine: true,
                        borderWidth: 2,
                        yAxisID: 'y',
                        pointStyle: 'rect',

                    },
                ]);
            }

        }

        setLoadingChart(false);
    }, [dataToChart]);

    if (!loadingChart) {
        return (
            <DetailsModalLineChartReport
                name={sensor}
                labels={dataToChart.labels}
                datasets={datasets}
                yMin={minData}
                yMax={maxData}
                alarms={alarms}
                powerTensionNominal={powerTensionNominal}
            />
        );
    }

}

